import { useData } from "../core/hooks/useData";
import { usePresenter } from "./types";
import { closest, closestIndex } from "../core/utils/dom";
import { newID } from "../core/utils/unique";
import { Text } from "../core/form/Text";
import { useDebounce } from "../core/hooks/useDebounce";
import { api } from "../api/api";
import { useGlobalHandler } from "../core/hooks/useGlobalHandler";
import { useApi } from "../core/hooks/useApi";
import { useRefresh } from "../core/hooks/useRefresh";
import { useRef, useState } from "react";

export function AusAddressSearch(props: {

    prop: string;
    className?: string;

	placeholder?: string,

}) {
    const data = useData();
	const presenter = usePresenter();

	const [qry, setQry] = useDebounce<string>(750);

	const v = data.value as any;

	const [isFocused, setIsFocused]	= useState(false);

	const {
        prop,
    } = props;

	const results = useApi<any[]>({
		request: () => {
			if (!qry) return;
			if (qry.split(" ").length < 3) return;

			return api.geo_search({
				qry,
			});
		}
	}, [qry])


	const id = useRef<string>();
	if (!id.current) id.current = newID();

	let items;
	if (results) {
		items = results.map((r, i) => {
			return (
				<div
					data-index={i}
					key={i}
					className="result padding-3 nowrap clickable show-hover"
				>
					{[
						r.number,
						r.street,
						r.locality,
						r.state,
						r.postcode
					].join(" ")}
				</div>
			);
		});
	}

	function selectAddr(a: any) {
		presenter.setValue("street", a.number + " " + a.street, data);
		presenter.setValue("locality", a.locality, data);
		presenter.setValue("state", a.state, data);
		presenter.setValue("postCode", a.postcode, data);

		setQry("", true);
		setIsFocused(false);

		data.setValue(prop, "");
	}

	//if (isSearching) { //} && !data.getValue(prop + "_manual")) {
		return (
			<div className={"relative " + id.current}>
				<div className="flex align-center">
					<Text
						prop={prop}
						placeholder={props.placeholder}
						onChange={(e, value) => {
							setQry(value);
						}}
						onFocus={() => {
							setIsFocused(true);
						}}
						onBlur={() => {
							setTimeout(() => {
								setIsFocused(false);
							}, 200);
						}}
					/>
					{/* <button
						className="flat"
						onClick={() => {
							data.setValue(prop + "_manual", true);
							setIsSearching(false);
						}}
					>Manually Enter</button> */}
				</div>
				{
					isFocused &&
					<div
						className="absolute font-small bg shadow z-popup"
						onClick={(e) => {
							const i = closestIndex(e.target, ".result");
							if (i < 0) {
								return;
							}

							selectAddr(results![i]);
						}}
					>
						{items as any}
					</div>
				}
			</div>
		);
	
	// } else {
	// 	return null;
		
	// 	// // not searching, show option to 
	// 	// return (
	// 	// 	<div>
	// 	// 		{
	// 	// 			!presenter.readOnly &&
	// 	// 			<button
	// 	// 				onClick={() => {
	// 	// 					presenter.setValue("careOf", "", data);
	// 	// 					presenter.setValue("line2", "", data);
	// 	// 					presenter.setValue("street", "", data);
	// 	// 					presenter.setValue("locality", "", data);
	// 	// 					presenter.setValue("state", "", data);
	// 	// 					presenter.setValue("postCode", "", data);

	// 	// 					setIsSearching(true);
	// 	// 				}}
	// 	// 			>Search</button>
	// 	// 		}
	// 	// 	</div>
	// 	// )


	// }

}

